const input = document.getElementById('searchbar-input');
const form = document.getElementById('searchbar-form');

input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        form.requestSubmit();
    }
});